import React, { useEffect, useState } from 'react'
import { Box, Tab, Tabs, Snackbar, Typography, LinearProgress, useTheme } from '@mui/material'
import PageHeaderWithIcons from '@/components/heder/PageHeaderWithIcons'
import { NavLink, useLocation, Outlet, useParams } from 'react-router-dom'
import { useAppTheme } from '@/theme/ThemeContext'

const Notifications: React.FC = () => {
  const theme = useTheme()
  const location = useLocation()
  const currentPath = location.pathname
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'
  const { siteId } = useParams()

  const value = currentPath.includes('addntion-actions')
    ? 1
    : currentPath.includes('manage-notifications')
      ? 2
      : 0

  const [ShowProSearch, setShowProSearch] = useState(true)
  const isManageTab = currentPath.includes('manage-notifications')
  const isAdditionalActions = currentPath.includes('addntion-actions')
  const [search, setSearch] = useState('')
  const [excelExportHandler, setExcelExportHandler] = useState<(() => void) | null>(null)
  const [isExporting, setIsExporting] = useState(false)
  const [exportProgress, setExportProgress] = useState(0)

  useEffect(() => {
    setShowProSearch(!isManageTab)
  }, [isManageTab])

  return (
    <Box
      width="100%"
      sx={{
        backgroundColor: isDarkMode ? '#091327' : theme.palette.background.default,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <PageHeaderWithIcons
        title="התראות"
        showSearch={!isAdditionalActions}
        showSearchInput={isManageTab}
        proSearch={ShowProSearch}
        placeholder="חיפוש התראה"
        onSearchChange={setSearch}
        onExcelExport={excelExportHandler ?? undefined}
      />

      <Box sx={{ width: '100%' }}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            display: 'flex',
            justifyContent: 'flex-end',
            width: '100%',
          }}
        >
          <Tabs
            value={value}
            textColor="primary"
            indicatorColor="primary"
            sx={{
              minWidth: 0,
              direction: 'rtl',
              '& .MuiTabs-indicator': {
                display: 'none', // Hide the jumpy indicator
              },
              '& .MuiTab-root': {
                color: isDarkMode ? '#fff' : 'inherit',
                minWidth: 'auto',
                px: 'clamp(12px, 1.2vw, 24px)',
                fontSize: 'clamp(13px, 1vw, 16px)',
                '&.Mui-selected': {
                  color: isDarkMode ? '#81B5FF' : 'primary.main',
                  borderBottom: `3px solid ${isDarkMode ? '#81B5FF' : theme.palette.primary.main}`,
                },
              },
            }}
          >
            <Tab
              label="מבט כללי"
              sx={{ textAlign: 'right', outline: 'none !important' }}
              component={NavLink}
              to={`/${siteId}/notifications`}
              end
            />
            <Tab
              label="פעולות נוספות"
              sx={{ textAlign: 'right', outline: 'none !important' }}
              component={NavLink}
              to={`/${siteId}/notifications/addntion-actions`}
            />
            <Tab
              label="ניהול התראות"
              sx={{ textAlign: 'right', outline: 'none !important' }}
              component={NavLink}
              to={`/${siteId}/notifications/manage-notifications`}
            />
          </Tabs>
        </Box>
      </Box>
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'auto' }}>
        <Outlet context={{ search, setExcelExportHandler, setIsExporting, setExportProgress }} />
      </Box>

      {/* Export progress indicator */}
      <Snackbar
        open={isExporting}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            bgcolor: isDarkMode ? '#1D325A' : '#fff',
            color: isDarkMode ? '#fff' : '#003F61',
            px: 3,
            py: 1.5,
            borderRadius: 2,
            boxShadow: 3,
            minWidth: 300,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                מייצא קובץ Excel...
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 40, textAlign: 'left' }}>
                {exportProgress}%
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={exportProgress}
              sx={{
                borderRadius: 1,
                height: 6,
                bgcolor: isDarkMode ? '#374151' : '#E4E7EB',
                '& .MuiLinearProgress-bar': {
                  bgcolor: '#81B5FF',
                  borderRadius: 1,
                },
              }}
            />
          </Box>
        </Box>
      </Snackbar>
    </Box>
  )
}

export default Notifications
